import { useEffect, useState } from 'react'
import { api } from '../api.js'

export default function Publication({ onFini }) {
  const [data, setData] = useState(null)
  const [enCours, setEnCours] = useState(false)

  const charger = () => api.publishPreview().then(setData)
  useEffect(() => { charger() }, [])   // eslint-disable-line

  if (!data) return <p className="chargement">Chargement…</p>

  async function publier() {
    setEnCours(true)
    await api.publish()
    await charger()
    onFini?.()
    setEnCours(false)
  }

  return (
    <>
      <h1>Mettre le portail à jour</h1>
      <p className="chapo">Voici ce qui va changer pour les habitants. Les dossiers déjà déposés
        continuent leur route sur la version qu'ils ont connue.</p>

      <div className="deux">
        <section className="carte">
          <h2>{data.changes.length ? `${data.changes.length} changement${data.changes.length > 1 ? 's' : ''}` : 'Aucun changement'}</h2>
          {data.changes.length ? (
            <>
              <ul className="changements">
                {data.changes.map((c, i) => (
                  <li key={i}><span className={`pk ${c.kind}`}>
                    {{ add: 'nouveau', mod: 'modifié', del: 'retiré' }[c.kind]}</span>{c.text}</li>
                ))}
              </ul>
              <button className="btn pri" onClick={publier} disabled={enCours}>
                {enCours ? 'Mise en ligne…' : 'Mettre en ligne maintenant'}
              </button>
            </>
          ) : <p className="aide">Votre brouillon et la version publique sont identiques.</p>}
        </section>

        <aside className="carte">
          <h2>Historique</h2>
          {data.history.length ? data.history.map((p, i) => (
            <details key={i}>
              <summary>{new Date(p.at).toLocaleString('fr-FR')} · {p.changes.length} changement(s)</summary>
              <ul>{p.changes.map((c, j) => <li key={j}>{c}</li>)}</ul>
            </details>
          )) : <p className="aide">Portail jamais mis en ligne.</p>}
        </aside>
      </div>
    </>
  )
}
